__turbopack_context__.v({
  "heroBlock": "HeroBlock-module__ib638W__heroBlock",
});
